export default __webpack_public_path__ + "static/media/login-signup-image.f860d14c.png";